export default __webpack_public_path__ + "static/media/icon.91f15e8f.svg";